export const zeroPad = (num = 0, places = 2) => {
  const zero = places - num?.toString().length + 1;
  return `${Array.from({ length: zero }).join('0')}${num}`;
};

export const uid = (prefix = '') => {
  return `${prefix}${Math.random().toString(36).substr(2, 9)}`;
};

export const imagePath = url => {
  const prefix = process.env.PREFIX_ASSETS_URL || null;
  if (url.startsWith('data:image')) return url;
  if (url.startsWith('http')) return url;
  return prefix ? `${prefix}${url}` : url;
};

export const validateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

export const isLightColor = color => {
  if (!color) return null;

  const rgb = hexToRgb(color);
  if (!rgb) return null;

  const { r, g, b } = rgb;
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128;
};

export const removeUnit = value => {
  return value.replace(/[^0-9.]/g, '');
};
